import { PureComponent } from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Header from '../components/Header';
import FreeTrialHeader from '../components/FreeTrialHeader';
import Navigation from '../components/Navigation';
import { ErrorBoundary } from '../components/common';
import PolicyAcceptanceModal from '../components/PolicyAcceptanceModal';
import BillingModal from '../components/settings/BillingModals';
import BillingModalHelper from '../components/settings/BillingModalHelper';
// import Clarity from '../utilities/Clarity'; // Disabled clarity tracking for the time being

class Layout extends PureComponent {
  billingModalProps = BillingModalHelper();

  render() {
    const {
      pageHeading,
      bredCrumbLinks,
      children,
      accountStatus,
      policyStatus,
      plan,
      freeTrialStatus,
      sideNavbarCollapsedView,
      permissions,
    } = this.props;
    document.title = pageHeading.preTitle;
    const url = new URL(window.location.href);
    const isFreeTrail =
      plan &&
      plan !== null &&
      plan.toLowerCase().includes('trial') &&
      accountStatus !== 'cancel' &&
      freeTrialStatus;
    const isCreator =
      permissions && permissions.includes('subscription_manage');
    return (
      <>
        <Navigation category={pageHeading.preTitle} />
        {isCreator &&
          accountStatus === 'cancel' &&
          url.pathname.split('/')[2] !== 'account-closed' &&
          url.pathname.split('/')[2] !== 'billing' &&
          this.billingModalProps.title && (
            <BillingModal modalProps={this.billingModalProps} />
          )}

        {isFreeTrail && isCreator && (
          <>
            <FreeTrialHeader />
            {/* Disabled clarity tracking for the time being */}
            {/* <Clarity /> */}
          </>
        )}
        <div
          className={
            isFreeTrail && isCreator
              ? `main-content free-trial ${
                  sideNavbarCollapsedView && 'collapsed-sidebar'
                }`
              : `main-content ${sideNavbarCollapsedView && 'collapsed-sidebar'}`
          }
        >
          <Header pageHeading={pageHeading} bredCrumbLinks={bredCrumbLinks} />
          {/* Trigger Policy Acceptance request model if there is any change in policy or terms */}
          {!policyStatus && <PolicyAcceptanceModal />}
          {(accountStatus === 'cancel' &&
            (url.pathname.split('/')[2] === 'billing' ||
              url.pathname.split('/')[2] === 'account-closed')) ||
          accountStatus !== 'cancel' ? (
            <Container fluid className="pt-4 content-wrapper">
              <ErrorBoundary>{children}</ErrorBoundary>
            </Container>
          ) : (
            ''
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    userReducer,
    billingReducer,
    collpasedSideNavbarToggle,
    permissionsReducer,
  } = state;

  return {
    accountStatus: billingReducer.accountStatus,
    policyStatus: userReducer.policyAcceptanceStatus,
    plan: userReducer.subscription.currentPlan,
    freeTrialStatus: userReducer.freeTrialStatus,
    sideNavbarCollapsedView: collpasedSideNavbarToggle.sideNavbarCollapsedView,
    permissions: permissionsReducer,
  };
};

Layout.propTypes = {
  freeTrialStatus: PropTypes.bool,
  accountStatus: PropTypes.string,
  pageHeading: PropTypes.object,
  bredCrumbLinks: PropTypes.array,
  children: PropTypes.any,
  policyStatus: PropTypes.bool,
  plan: PropTypes.string,
  sideNavbarCollapsedView: PropTypes.bool,
  permissions: PropTypes.array,
};

export default connect(mapStateToProps)(Layout);
